itsoftApp.createModule("headerFix", ["windowScroll", "windowResize"], function() {
    var header = document.querySelector(".page-header");
    var pageWrapper = document.querySelector(".l-wrapper");

    var setPagePadding = function () {
        pageWrapper.style.paddingTop = itsoftApp.utils.getHeaderHeight();
    }

    itsoftApp.modules.windowResize.addEvent(setPagePadding);
});